import {axios} from "./config"
export class FR extends axios{
   axios;
   token;
   constructor(){
   super();
   this.axios=this.axiosConfig();
 }
 async addOld(data){
    let formData=new FormData();
    for(let key in data){
        formData.append(key,data[key])
    }
        try{
        let result=await this.axios({
        method:"post",
        url:"fr/add",
        data:formData
    });
        return new Promise((res,rej)=>{
            res(result.data);
        })
        }catch(e){
            return new Promise((res,rej)=>{
                rej(e);
            })
          
        }
          }
 async add(data){
    let formData=new FormData();
    formData.append("employeeId",data.employeeId);
    formData.append("firstName",data.firstName);
    formData.append("lastName",data.lastName);
    for (let i = 0; i < data.images.length; i++) {
    formData.append('images', data.images[i]);
    }
        try{
        let result=await this.axios({
        method:"post",
        url:"fr/addWithMultiple",
        data:formData
    });
        return new Promise((res,rej)=>{
            res(result.data);
        })
        }catch(e){
            return new Promise((res,rej)=>{
                rej(e);
            })
          
        }
          }
          async updatedImages(data){
            let formData=new FormData();
            for(let key in data){
                formData.append(key,data[key])
            }
                try{
                let result=await this.axios({
                method:"post",
                url:"fr/updateImages",
                data:formData
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
                  }
          async updateEmployee(data){
            let formData=new FormData();
            for(let key in data){
                formData.append(key,data[key])
            }
                try{
                let result=await this.axios({
                method:"patch",
                url:"fr",
                data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
                  }
          async getAllNotification(){
           
                try{
                let result=await this.axios({
                method:"post",
                url:"fr/getAllNotification",
                
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
                  }
          async seeAllNotification(){
           
                    try{
                    let result=await this.axios({
                    method:"post",
                    url:"fr/seeAllNotification",
                    
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
                      }
          async getAllData(status){
            try{
            let result=await this.axios({
            method:"post",
            url:"fr/getAllData",
            data:status
        });
            return new Promise((res,rej)=>{
                res(result.data);
            })
            }catch(e){
                return new Promise((res,rej)=>{
                    rej(e);
                })
              
            }
              }

              async updatedImagesWithMultiple(data){
                let formData=new FormData();
                console.log(data)
                formData.append("employeeId",data.employeeId);
                formData.append("deleteImages",JSON.stringify(data.deleteImages));
                for (let i = 0; i < data.images.length; i++) {
                formData.append('images', data.images[i]);
                }
                    try{
                    let result=await this.axios({
                    method:"post",
                    url:"fr/updateAllImages",
                    data:formData
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
                      }
              async getAllDataWithPagination(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"fr/getAllDataWithPagination",
                data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
                  }
              async frInOut(data){
                try{
                let result=await this.axios({
                method:"post",
                url:"fr/firstInLastOutReport",
                data:data
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
                  }
                  async frInOutWithPagination(data){
                    try{
                    let result=await this.axios({
                    method:"post",
                    url:"fr/firstInLastOutReportWithPagination",
                    data:data
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
                      }
                  async employeeAttendanceDetails(data){
                
                    try{
                    let result=await this.axios({
                    method:"post",
                    url:"fr/employeeAttendanceDetails",
                    data:data,
                });
                    return new Promise((res,rej)=>{
                        res(result.data);
                    })
                    }catch(e){
                        return new Promise((res,rej)=>{
                            rej(e);
                        })
                      
                    }
                      }
                async employeeAttendanceDetailsWithpagination(data){
                    console.log(data)
                
                        try{
                        let result=await this.axios({
                        method:"post",
                        url:"fr/employeeAttendanceDetailsWithPagination",
                        data:data,
                    });
                        return new Promise((res,rej)=>{
                            res(result.data);
                        })
                        }catch(e){
                            return new Promise((res,rej)=>{
                                rej(e);
                            })
                          
                        }
                          }
                          
              async delete(employeeId){
              
                try{
                let result=await this.axios({
                method:"post",
                url:"fr/delete",
                data:{employeeId}
            });
                return new Promise((res,rej)=>{
                    res(result.data);
                })
                }catch(e){
                    return new Promise((res,rej)=>{
                        rej(e);
                    })
                  
                }
                  }


                  async uploadFromExcel(file){
                    let formData=new FormData();
                    formData.append("file",file)
                    
                        try{
                        let result=await this.axios({
                        method:"post",
                        url:"fr/uploadFromExcel",
                        data:formData
                    });
                        return new Promise((res,rej)=>{
                            res(result.data);
                        })
                        }catch(e){
                            return new Promise((res,rej)=>{
                                rej(e);
                            })
                          
                        }
                          }  
                          async getCompanies(){
                            try{
                            let result=await this.axios({
                            method:"post",
                            url:"fr/getCompaniesData",
                            
                        });
                            return new Promise((res,rej)=>{
                                res(result.data);
                            })
                            }catch(e){
                                return new Promise((res,rej)=>{
                                    rej(e);
                                })
                              
                            }
                              } 
                              
                              async getImagesFromBackend(employeeId){
           
                                try{
                                let result=await this.axios({
                                method:"post",
                                url:"fr/checkImagesOnBackend",
                                data:{employeeId}
                                
                            });
                                return new Promise((res,rej)=>{
                                    res(result.data);
                                })
                                }catch(e){
                                    return new Promise((res,rej)=>{
                                        rej(e);
                                    })
                                  
                                }
                                  }
                                                          
        
}